const MUTATION_TYPE = {
  setContent: 'setContent',
  pushContent: 'pushContent',
  setEvents: 'setEvents',
  setNews: 'setNews',
  pushNews: 'pushNews',
  pushEvents: 'pushEvents',
  setGPClasses: 'setGPClasses',
  setGPFields: 'setGPFields',
  setContentData: 'setContentData',
  setContentType: 'setContentType',
  clearContent: 'clearContent',
  setCountOfWaitingContent: 'setCountOfWaitingContent',
  setAllPartners: 'setAllPartners',
  updateTitle: 'updateTitle',
  updateEventSettings: 'updateEventSettings',
  updateEventVoting: 'updateEventVoting',
  updateShortDescription: 'updateShortDescription',
  updateFullDescription: 'updateFullDescription',
  updateDate: 'updateDate',
  updateVideos: 'updateVideos',
  updateImages: 'updateImages',
  setAvatar: 'setAvatar',
  setVideoPreview: 'setVideoPreview',
  setAvatarWithoutFiles: 'setAvatarWithoutFiles',
  deleteAvatar: 'deleteAvatar',
  deleteFile: 'deleteFile',
  addLinkToDescription: 'addLinkToDescription',
  addFiles: 'addFiles',
  setOrgsForEvent: 'setOrgsForEvent',
  addFileName: 'addFileName',
  resetFileNames: 'resetFileNames',
  updateRating: 'updateRating'
}

const ACTION_TYPE = {
  fetchAllContent: 'fetchAllContent',
  fetchEvents: 'fetchEvents',
  fetchNews: 'fetchNews',
  fetchGPClasses: 'fetchGPClasses',
  fetchGPFields: 'fetchGPFields',
  fetchSelectedContent: 'fetchSelectedContent',
  fetchSelectedClass: 'fetchSelectedClass',
  fetchUserClass: 'fetchUserClass',
  fetchSelectedPartner: 'fetchSelectedPartner',
  fetchAllPartners: 'fetchAllPartners',
  fetchGPClassesForMap: 'fetchGPClassesForMap',
  fetchAllPartnersForMap: 'fetchAllPartnersForMap',
  fetchCountOfWaitingContent: 'fetchCountOfWaitingContent',
  saveContent: 'saveContent',
  saveContentByTeacher: 'saveContentByTeacher',
  addContent: 'addContent',
  addContentByTeacher: 'addContentByTeacher',
  deleteContent: 'deleteContent',
  sendContentToVerification: 'sendContentToVerification',
  sendResultOfVerification: 'sendResultOfVerification',
  changeAvatar: 'changeAvatar',
  changeVideoPreview: 'changeVideoPreview',
  addNewFiles: 'addNewFiles',
  addNewLoadedFiles: 'addNewLoadedFiles',
  addLink: 'addLink',
  fetchOrgsForEvent: 'fetchOrgsForEvent',
  fetchMemberStatus: 'fetchMemberStatus',
  updateMemberStatus: 'updateMemberStatus',
  deleteAvatar: 'deleteAvatar'
}

const GETTER_TYPE = {
  getEvents: 'getEvents',
  getNews: 'getNews',
  getGPClasses: 'getGPClasses',
  getGPFields: 'getGPFields',
  getContent: 'getContent',
  getContentType: 'getContentType',
  getTitlePrefix: 'getTitlePrefix',
  getCountOfWaitingContent: 'getCountOfWaitingContent',
  getAllPartners: 'getAllPartners',
  getOrgsForEvent: 'getOrgsForEvent',
  getCourses: 'getCourses',
  getSims: 'getSims',
  getFileNames: 'getFileNames'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
